<template>
  <div class="container">
    <header>
      <div class="logo">
        <div class="logo-text">
          <h1>卫人之家</h1>
        </div>
      </div>
    </header>
    <section class="modules-section">
      <div class="modules-grid">
        <!-- 教育模块 -->
        <div class="module-card education" @click="goPage('教育')">
          <div class="module-icon">
            <i class="fas fa-graduation-cap"></i>
          </div>
          <h3>专业教育</h3>
          <p>提供职称晋级、医学继续教育、技能培训等专业学习资源，助力医护人员持续成长。</p>
        </div>

        <!-- 生活模块 -->
        <div class="module-card life" @click="goPage('生活')">
          <div class="module-icon">
            <i class="fas fa-heartbeat"></i>
          </div>
          <h3>健康生活</h3>
          <p>关注医护人员身心健康，提供减压指导、健康管理、生活服务等全方位支持。</p>
        </div>

        <!-- 图书模块 -->
        <div class="module-card book" @click="goPage('图书')">
          <div class="module-icon">
            <i class="fas fa-book-medical"></i>
          </div>
          <h3>医学图书</h3>
          <p>最新医学文献、专业书籍、临床指南等资源，满足医护人员学术研究和临床需求。</p>
        </div>

        <!-- 福利模块 -->
        <div class="module-card welfare" @click="goPage('福利')">
          <div class="module-icon">
            <i class="fas fa-gift"></i>
          </div>
          <h3>专属福利</h3>
          <p>为医护人员提供的专属优惠、补贴政策、休息权益等福利信息与申请通道。</p>
        </div>
      </div>
    </section>
    <bind-personnel ref="bindPersonnel" @success="loadData"></bind-personnel>
  </div>
</template>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
}

body {
  background: linear-gradient(135deg, #f0f8ff 0%, #e6f7ff 100%);
  color: #333;
  min-height: 100vh;
  padding: 20px;
  line-height: 1.6;
}

.container {
  margin: 0 auto;
  padding: 20px;
}

/* 头部样式 */
header {
  text-align: center;
  margin-bottom: 30px;
  padding-top: 20px;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 15px;
}

.logo-icon {
  background: linear-gradient(135deg, #4a9eff, #6bb7ff);
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 10px rgba(74, 158, 255, 0.2);
}

.logo-icon i {
  font-size: 24px;
  color: white;
}

.logo-text h1 {
  font-size: 1.8rem;
  color: #2c6db3;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.logo-text p {
  font-size: 0.9rem;
  color: #66a3ff;
  font-weight: 400;
}

.slogan {
  font-size: 1.1rem;
  color: #5a8fd8;
  font-weight: 400;
  padding: 10px 0;
  border-top: 1px solid rgba(90, 143, 216, 0.2);
  margin-top: 10px;
}

/* 模块展示区域 */
.modules-section h2 {
  text-align: center;
  font-size: 1.4rem;
  color: #3a7bc8;
  margin-bottom: 25px;
  font-weight: 500;
  position: relative;
  padding-bottom: 8px;
}

.modules-section h2::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(to right, #6bb7ff, #4a9eff);
  border-radius: 3px;
}

.modules-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.module-card {
  background: white;
  border-radius: 16px;
  padding: 25px 20px;
  box-shadow: 0 6px 20px rgba(106, 179, 255, 0.1);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  border: 1px solid rgba(106, 179, 255, 0.15);
  position: relative;
  overflow: hidden;
}

.module-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(to right, #6bb7ff, #4a9eff);
}

.module-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 25px rgba(106, 179, 255, 0.15);
}

.module-icon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  font-size: 30px;
  color: white;
}

.education .module-icon {
  background: linear-gradient(135deg, #4a9eff, #6bb7ff);
}

.life .module-icon {
  background: linear-gradient(135deg, #66ccff, #4ab3ff);
}

.book .module-icon {
  background: linear-gradient(135deg, #80ccff, #5ab5ff);
}

.welfare .module-icon {
  background: linear-gradient(135deg, #99ddff, #73c8ff);
}

.module-card h3 {
  font-size: 1.3rem;
  color: #2c6db3;
  margin-bottom: 12px;
  font-weight: 600;
}

.module-card p {
  color: #6699cc;
  font-size: 0.95rem;
  line-height: 1.5;
}

/* 底部信息 */
footer {
  margin-top: 40px;
  text-align: center;
  color: #88aadd;
  font-size: 0.9rem;
  padding-top: 20px;
  border-top: 1px solid rgba(136, 170, 221, 0.2);
}

.footer-note {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 10px;
  color: #5a8fd8;
}

/* 响应式调整 */
@media (max-width: 400px) {
  .modules-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }

  .logo-text h1 {
    font-size: 1.6rem;
  }

  .module-card {
    padding: 22px 18px;
  }
}

/* 动画效果 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.module-card {
  animation: fadeInUp 0.5s ease forwards;
  opacity: 0;
}

.education {
  animation-delay: 0.1s;
}

.life {
  animation-delay: 0.2s;
}

.book {
  animation-delay: 0.3s;
}

.welfare {
  animation-delay: 0.4s;
}

/* 添加更多模块提示 */
.more-modules {
  margin-top: 30px;
  text-align: center;
  color: #88aadd;
  font-size: 0.95rem;
}

.more-modules i {
  margin-right: 8px;
  color: #66a3ff;
}
</style>

<script>
import BindPersonnel from '@/components/BindPersonnel'
import mixinLoad from '@/mixin/mixin-load.js'
import {viewH5} from "@/api/user";
import nativeApi from "@/utils/native-bridge";

export default {
  name: 'RenWei',
  components: {BindPersonnel},
  mixins: [mixinLoad],
  data() {
    return {
      loading: true
    }
  },
  methods: {
    loadData() {
      this.loading = true
    },
    goPage(type) {
      viewH5(type).then((rep) => {
        if (!rep.data) {
          this.showTip('敬请期待')
          return;
        }
        nativeApi.forwardPage({
          uri: rep.data
        })
      }).catch((err) => {
        console.info(err)
      })
    },
  },
  created() {
    // Promise.all([this.preCheck()]).then(() => {
    // })
    // this.loadData()
  }
}
</script>
